import React from 'react';
import { SelectOption } from 'global';
import { Stack, Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField, InputField } from 'components/form';
import { FormSectionHeader, FormSectionHeaderProps } from 'components/shared/FormSectionHeader';
import { LenderDeskingPanelFormValues } from '../../../types';

interface Props<Value extends string> extends FormSectionHeaderProps<Value> {
  customers: SelectOption[];
  isSectionDisabled?: boolean;
}

export const CustomerSection = <Value extends string>({
  customers,
  isSectionDisabled = false,
  ...headerProps
}: Props<Value>) => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  return (
    <Stack gap="1rem">
      <FormSectionHeader {...headerProps} />

      <Stack gap="1rem">
        <AutocompleteField
          control={control}
          options={customers}
          name="customer.contact"
          disabled={isSectionDisabled}
          textFieldProps={{ label: 'Select Contact', size: 'small' }}
        />

        <InputField
          control={control}
          name="customer.name"
          label="Customer name"
          inputProps={{ disabled: isSectionDisabled }}
        />

        <Box sx={{ display: 'grid', gap: '1rem', gridTemplateColumns: '1fr 1fr' }}>
          <InputField
            label="Email"
            control={control}
            name="customer.email"
            inputProps={{ type: 'email', disabled: isSectionDisabled }}
          />

          <InputField
            control={control}
            label="Phone number"
            name="customer.phone"
            inputProps={{ mask: '(999) 999-9999', disabled: isSectionDisabled }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};
